export enum DisplayContext {
  Dashboard = `DASHBOARD`,
  Funnels = `FUNNELS`,
  Global = `GLOBAL`,
  Insights = `INSIGHTS`,
}

export enum EmptyState {
  Global = `global`,
  ReportIsSubscribed = `report-is-subscribed`,
  ReportNotSubscribed = `report-is-not-subscribed`,
  UpsellAutoAndCustomAlerts = `upsell-both`,
  UpsellAutoHasCustomAlerts = `upsell-only-automatic-insights-because-has-custom-alerts`,
  UpsellAutoNoCustomAlerts = `upsell-automatic-insights-but-cant-for-custom-alerts`,
}

export const EmptyStateTexts = {
  [EmptyState.Global]: {
    primary: `No current Alerts detected.`,
    secondary: `Mixpanel automatically finds interesting trends and anomalies in your data. Alerts enabled for all your reports will appear here.`,
  },
  [EmptyState.ReportIsSubscribed]: {
    primary: `No Automatic Insights detected.`,
    secondary: ``,
  },
  [EmptyState.ReportNotSubscribed]: {
    primary: `Unsubscribed from Automatic Insights`,
    secondary: `Mixpanel automatically finds interesting trends and anomalies in your data. Subscribe above to begin receiving alerts for this report here.`,
  },
  [EmptyState.UpsellAutoHasCustomAlerts]: {
    primary: `Custom Alerts are available with your plan. Upgrade to receive Automatic Insights.`,
    secondary: `Harness the power of machine learning to surface interesting trends and anomalies in your data.`,
  },
  [EmptyState.UpsellAutoAndCustomAlerts]: {
    primary: `Upgrade to receive Automatic Insights and Custom Alerts.`,
    secondary: `Surface interesting trends and anomalies in your data with Automatic Insights or customize alerts for exactly what you care about.`,
  },
  [EmptyState.UpsellAutoNoCustomAlerts]: {
    primary: `Upgrade to receive Automatic Insights.`,
    secondary: `Harness the power of machine learning to surface interesting trends and anomalies in your data.`,
  },
};
